import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function LegalFooter() {
  return (
    <footer className="bg-[#0D2137] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link to="/" className="cursor-pointer">
          <Logo variant="light" />
        </Link>
        <p className="text-white/35 text-xs text-center">
          © {new Date().getFullYear()} Mediatio Global — Todos los derechos reservados.
        </p>
        <div className="flex items-center gap-5">
          <Link to="/politica-de-privacidad" className="text-white/35 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">Privacidad</Link>
          <Link to="/aviso-legal" className="text-white/35 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">Aviso Legal</Link>
          <Link to="/politica-de-cookies" className="text-white/35 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">Cookies</Link>
        </div>
      </div>
    </footer>
  );
}
